"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _icon = _interopRequireDefault(require("../icon"));

var _utils = require("../../utils");

var styles = {
  "logo": "logo-logo-wCAGq",
  "logo-icon": "logo-logo-icon-1JnTB",
  "logoIcon": "logo-logo-icon-1JnTB"
};

var Logo = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var _ref$children = _ref.children,
      children = _ref$children === void 0 ? 'CORE' : _ref$children,
      className = _ref.className,
      _ref$src = _ref.src,
      src = _ref$src === void 0 ? '#core-symbol' : _ref$src,
      _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? 'CORE' : _ref$alt,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'span' : _ref$tag,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, ["children", "className", "src", "alt", "tag"]);
  return /*#__PURE__*/_react["default"].createElement(Tag, (0, _extends2["default"])({
    className: _utils.classNames.use(styles.logo, className)
  }, restProps), /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    src: src,
    alt: alt,
    className: styles.logoIcon
  }), /*#__PURE__*/_react["default"].createElement("span", null, children));
});

var _default = Logo;
exports["default"] = _default;